import { styled } from "@mui/material/styles";

import Icons from "assets";

/** The asset set has the double chevron pointing forward only, so "first page" mirrors it. */
export const SkipBackIcon = styled(Icons.DoubleChevron)({ transform: "scaleX(-1)" });
